import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import moment from 'moment';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';

const _CommencementDate = (props) => {
    const { commencementDate } = props;
    const dateLabel = moment(commencementDate).format('DD/MM/YYYY');
    return (
        <QuoteCard title="Commencement date" path="commencement_date">
            <QuoteQuestionPlainItem title="Date" content={dateLabel} />
        </QuoteCard>
    );
};

_CommencementDate.propTypes = {
    commencementDate: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        commencementDate: quoteFormSelector(state).getIn(['coverDetail', 'commencementDate'])
    };
};

const CommencementDate = connect(mapStateToProps)(_CommencementDate);

export { CommencementDate, _CommencementDate };
